import type { TablePaginationConfig } from 'antd'

export const DEVICES_PER_PAGE = 10

export interface TableParams {
  pagination?: TablePaginationConfig
  order?: string
  field?: string
}
